// import { BsArrowRight } from "react-icons/bs";

// import { BsArrowsFullscreen } from "react-icons/bs";

import { GoHeart, GoHeartFill } from "react-icons/go";
import { selectFavorites, selectTogglingProductId, toggleFavorite } from "../../redux/slices/favoritesSlice";
import { useDispatch, useSelector } from "react-redux";

import BingLoader from "../Loader/BingLoader";
import { Link } from "react-router-dom";
import LoaderMini from "../Loader/LoaderMini";
import { useTranslation } from "react-i18next";

// import { TbShoppingBag } from "react-icons/tb";

// import { FaStar } from "react-icons/fa6";

const TopSellerItem = ({ product }) => {
  const dispatch = useDispatch();

  const { i18n } = useTranslation();

  const { categories, loading } = useSelector((state) => state.categories);

  const categoryId = product?.category_id;

  const category = categories.find((cat) => cat.id === categoryId);

  const favorites = useSelector(selectFavorites) || [];

  const isFavorite = favorites.some((fav) => fav.product_id === product.id);

  const togglingProductId = useSelector(selectTogglingProductId);

  const isToggling = togglingProductId === product.id;

  const handleToggleFavorite = (productId) => {
    dispatch(toggleFavorite(productId));
  };

  return (
    <div className="rounded-2xl items-start justify-center flex h-full ">
      <div className="flex flex-col items-center justify-center gap-2">
        <Link to={`/products/${product?.id}`} className="lg:w-[16.68rem] lg:h-[18.2rem] 
            w-[9.857rem] h-[9.857rem]">
          <div
            className="lg:w-[16.68rem] lg:h-[18.2rem] relative 
            w-[9.857rem] h-[9.857rem]"
          >
            <img
              src={product.website_image}
              alt={i18n.language === "en"
                ? product?.english_name
                : product?.arabic_name}
              className="w-[9.875rem] lg:w-[16.68rem] h-[9.857rem] 
                lg:h-[18.2rem]  object-cover rounded-2xl hover:border border-blue-500"
            />
            <div
              className="absolute top-3 right-3 flex flex-col 
              items-center justify-center gap-3"
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleToggleFavorite(product.id);
                }}
                title={isFavorite ? "Remove from favorites" : "Add to favorites"}
                className="w-[2.125rem] h-[2.125rem] lg:w-12 lg:h-12 z-10
                rounded-full bg-white flex items-center justify-center pointer-events-auto
                hover:border hover:border-purble-2">
                {isToggling ? <BingLoader /> : isFavorite
                  ? <GoHeartFill className="size-4 lg:size-6 text-red-500" />
                  : <GoHeart className="size-4 lg:size-6" />}
              </button>
              {/* <button className="w-[2.125rem] h-[2.125rem] lg:w-12 lg:h-12 rounded-full bg-white flex items-center justify-center">
                <BsArrowsFullscreen className="size-4 lg:size-6" />
              </button>
              <button className="w-[2.125rem] h-[2.125rem] lg:w-12 lg:h-12 rounded-full bg-white flex items-center justify-center">
                <TbShoppingBag className="size-4 lg:size-6" />
              </button> */}
            </div>
            {/* <div
              className="absolute top-3 left-3 w-[69px] lg:w-[107px] h-[27px]
               bg-[#CC298F] flex items-center justify-center rounded-full 
               lg:h-[42px]"
            >
              <p className="text-xs lg:text-lg text-white">50% Sale</p>
            </div> */}
          </div>
        </Link>
        <div
          className="flex flex-col items-start justify-start w-[9.875rem] lg:w-full 
            px-2 mt-1"
        >
          <div className="w-full items-start justify-between flex mb-1">
            <Link to={`/products/${product?.id}`}>
              <p className="text-sm lg:text-base pointer-events-auto font-medium text-blue-2 
            ">{i18n.language === "en"
                  ? product?.english_name
                  : product?.arabic_name}</p>
            </Link>
            <Link to={`/categories/${category?.id}`}>
              <div className="lg:text-base text-sm 
              text-gray-500  pointer-events-auto font-meduium">
                {loading ? <LoaderMini color="bg-blue-500" /> :
                  i18n.language === "en"
                    ? category?.english_name
                    : category?.arabic_name
                }
              </div>
            </Link>
            {/* <div className="flex items-center justify-center gap-2 ">
              <FaStar className="text-yellow-400 size-4 lg:size-7" />
              <span className="lg:text-2xl text-xs">5.0</span>
            </div> */}
          </div>

          <div className="flex gap-1 items-center justify-center">
            <p className="text-base lg:text-base text-blue-2 font-normal">{product.price}</p>
            <p className="text-base lg:text-base text-blue-2">{i18n.language === "en"
              ? "SAR"
              : "ر.س"}</p>
          </div>
          {/* <div>
                <button className="flex items-center justify-center gap-2">
                  <span className="text-blue-2">Shop Now</span>
                  <BsArrowRight className="translate-y-[1px]" />
                </button>
              </div> */}
        </div>
      </div>
    </div>
  );
};
export default TopSellerItem;
